import(/* webpackMode: "eager" */ "/vercel/path0/src/app/gioi-thieu/page.tsx");
